import { render, staticRenderFns } from "./PreviousMentorships.vue?vue&type=template&id=8258df3e&scoped=true&"
import script from "./PreviousMentorships.vue?vue&type=script&lang=js&"
export * from "./PreviousMentorships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8258df3e",
  null
  
)

export default component.exports